import { IntlShape } from 'react-intl';
import { messages } from './messages';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.Specializations),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['specializations'],
    },
  ],
  properties: {
    specializations: {
      title: intl.formatMessage(messages.Specializations),
      description: intl.formatMessage(messages.SpecializationsHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'object_browser',
          widgetProps: {
            selectableTypes: ['Specialization'],
          },
        },
      },
      default: [],
    },
  },
  required: [],
});

export default Schema;
